import { MutationTree } from 'vuex';
import * as types from '@vue-storefront/core/modules/user/store/mutation-types';
import UserState from '@vue-storefront/core/modules/user/types/UserState';
import moment from 'moment-timezone';

const mutations: MutationTree<UserState> = {
  [types.USER_TOKEN_CHANGED] (state, payload) {
    state.token = payload.newToken ? payload.newToken : null
    if (payload.meta && payload.meta.refreshToken) {
      state.refreshToken = payload.meta.refreshToken // SSR only; the browser holds it as the HttpOnly rut cookie (K2-3138)
    }
    if(state.token === null && state.refreshToken === null) {
        state.current = null
    }
  },
  [types.USER_START_SESSION] (state) {
    state.session_started = new Date(moment().tz('Europe/Kiev').format())
  },
  [types.USER_GROUP_TOKEN_CHANGED] (state, token) {
    state.groupToken = token
  },
  [types.USER_GROUP_CHANGED] (state, groupId) {
    state.groupId = groupId
  },
  [types.USER_INFO_LOADED] (state, currentUser) {
    state.current = currentUser;
  },
  [types.USER_ORDERS_HISTORY_LOADED] (state, ordersHistory) {
    state.last_page = ordersHistory.last_page
    if (ordersHistory.old_location === ordersHistory.current_location) {
      if (ordersHistory.page > state.current_page) {
        state.current_page = ordersHistory.page
        state.orders_history = state.orders_history.concat(ordersHistory.items)
      }
    } else {
      state.current_page = ordersHistory.page
      state.orders_history = state.orders_history.concat(ordersHistory.items)
    }
  },
  [types.USER_ORDER_IN_ORDER_HISTORY_UPDATE] (state, payload) {
    let order = state.orders_history.find(o => o.id === payload.id),
      orderIdx = state.orders_history.indexOf(order)
    order = Object.assign({}, order, payload.data)
    state.orders_history.splice(orderIdx, 1, order)
  },
  [types.USER_END_SESSION] (state) {
    state.token = null
    state.refreshToken = null
    state.current = null
    state.session_started = null
  },
  [types.USER_LOCAL_DATA_LOADED] (state, readed = false) {
    state.local_data_loaded = readed
  },
  setOrder (state, payload) {
    state.order = payload.order
  },
  setOrderItems (state, payload) {
    let order = state.orders_history.items.find(item => {
      return item.id === payload.orderId
    })
    order.items = payload.items
    order.total_tax = 1000
  },
  setOrderedLocations (state, payload) {
    state.ordered_locations = payload.locations;
  },
  clearOrderHistory (state) {
    state.current_page = 0
    state.orders_history = []
    state.ordered_locations = []
  },
  addedAgeConfirmationProduct (state, product) {
    state.orderAgeConfirmation = product
  },
  [types.USER_PHONE_NUMBER_VERIFIED] (state) {
    state.current.phone_verified = true
  },
  [types.USER_HEADERS_UPDATE] (state, headers) {
    state.headers = headers
  }
}

export default mutations
